import { useTranslation } from "react-i18next";

export interface ResultCountProps {
  count: number;
}

/**
 * "12 productos" — cuántos se están viendo tras aplicar el filtro.
 *
 * Singular y plural son DOS claves de traducción, no una con un "(s)"
 * pegado: en español "1 productos" está mal, y quien traduzca al inglés
 * necesita poder escribir las dos formas.
 *
 * `aria-live="polite"` avisa del cambio al filtrar. Sin él, quien no ve la
 * rejilla pulsa un chip y no recibe ninguna señal de que algo pasó.
 */
export function ResultCount({ count }: ResultCountProps) {
  const { t } = useTranslation();

  return (
    <p
      aria-live="polite"
      className="text-[11px] font-medium uppercase tracking-ds-label-wide text-ds-ink-3"
    >
      {count === 1
        ? t("{{n}} producto", { n: count })
        : t("{{n}} productos", { n: count })}
    </p>
  );
}
